import React from 'react'
import { AppBar, Toolbar, Box, Button } from '@mui/material'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import logo from '../resources/logo.jpeg'
import * as ROUTES from '../routes'
import CurrencyIndicator from './currencyIndicator'

const NAV_LINKS = [
    { label: 'Market',      to: ROUTES.PROPERTIES  },
    { label: 'Rentals',     to: ROUTES.RENTALS     },
    { label: 'Sell',        to: ROUTES.SELL        },
    { label: 'Landscaping', to: ROUTES.LANDSCAPING },
    { label: 'About',       to: ROUTES.ABOUT       },
    { label: 'Contact',     to: ROUTES.CONTACT     },
]

export default function AppBarFull() {
    const location = useLocation()

    const showCurrency =
        location.pathname === ROUTES.ROOT ||
        location.pathname.startsWith(`/${ROUTES.HOME}`) ||
        location.pathname.startsWith(`/${ROUTES.PROPERTIES}`) ||
        location.pathname.startsWith(`/${ROUTES.RENTALS}`)

    return (
        <AppBar position='sticky' elevation={0}>
            <Toolbar sx={{ minHeight: 64, px: { md: 4, lg: 6 }, gap: 0 }}>

                {/* Logo */}
                <Box
                    component={RouterLink}
                    to='/'
                    sx={{ display: 'flex', alignItems: 'center', mr: 4, flexShrink: 0, textDecoration: 'none' }}
                >
                    <img
                        src={logo}
                        alt='Choice Real Estate'
                        style={{ height: 96, width: 'auto', display: 'block' }}
                    />
                </Box>

                {/* Nav links — single row, no wrap */}
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: 0.5, flex: 1 }}>
                    {NAV_LINKS.map(link => {
                        const active =
                            location.pathname === `/${link.to}` ||
                            location.pathname.startsWith(`/${link.to}/`)
                        return (
                            <Button
                                key={link.to}
                                component={RouterLink}
                                to={link.to}
                                size='medium'
                                sx={{
                                    color: active ? 'primary.main' : 'text.primary',
                                    fontWeight: active ? 700 : 500,
                                    whiteSpace: 'nowrap',
                                    px: 1.5,
                                    borderBottom: active ? '2px solid' : '2px solid transparent',
                                    borderColor: active ? 'primary.main' : 'transparent',
                                    borderRadius: 0,
                                    pb: '2px',
                                    '&:hover': {
                                        color: 'primary.main',
                                        backgroundColor: 'transparent',
                                        borderColor: 'primary.light',
                                    },
                                }}
                            >
                                {link.label}
                            </Button>
                        )
                    })}
                </Box>

                {/* Currency / unit picker */}
                {showCurrency && (
                    <Box sx={{ flexShrink: 0 }}>
                        <CurrencyIndicator />
                    </Box>
                )}
            </Toolbar>
        </AppBar>
    )
}
